export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/brand_voice_tone.afd6ce2.svg";